import { render, staticRenderFns } from "./TotalLogisticCost.vue?vue&type=template&id=45629bb5&scoped=true&"
import script from "./TotalLogisticCost.vue?vue&type=script&lang=js&"
export * from "./TotalLogisticCost.vue?vue&type=script&lang=js&"
import style0 from "./TotalLogisticCost.vue?vue&type=style&index=0&id=45629bb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45629bb5",
  null
  
)

export default component.exports